import escapeHtml from '../../utils/escapeHtml';

// One package checkout refused because no items were chosen for it (ENG-1683).
// The server returns only what the client submitted, never a catalog name:
// submit does not scope product ids to the parent, so reflecting names would
// expose other studios' catalogs.
export interface UnconfiguredBundle {
  order_key: string | null;
  product_id: number;
}

interface CartItem {
  productId?: number | string;
  productName?: string;
}

type Orders = Record<string, { cartItems?: CartItem[] } | undefined>;

interface Alert {
  icon: 'warning';
  title: string;
  html: string;
}

const FALLBACK_NAME = 'A package in your cart';

const packageName = (
  bundle: UnconfiguredBundle,
  orders: Orders | undefined,
): string => {
  const cartItems =
    (bundle.order_key && orders?.[bundle.order_key]?.cartItems) || [];
  const item = cartItems.find(
    (cartItem) => String(cartItem.productId) === String(bundle.product_id),
  );
  return item?.productName || FALLBACK_NAME;
};

// The package can't be completed from the cart, so the only way forward is to
// remove it and build it again.
const unconfiguredBundlesAlert = (
  bundles: UnconfiguredBundle[] | undefined,
  orders: Orders | undefined,
): Alert => {
  const names = (bundles || [])
    .map((bundle) => `<li>${escapeHtml(packageName(bundle, orders))}</li>`)
    .join('');

  return {
    icon: 'warning',
    title: 'Finish Building Your Package',
    html: `
      <p>No items were chosen for this package in your cart:</p>
      ${names ? `<ul>${names}</ul>` : ''}
      <p>Please remove it from your cart, then add the package again and choose your items.</p>
    `,
  };
};

export default unconfiguredBundlesAlert;
